<script setup lang="ts">
import { ButtonPrimaryAccented, ButtonSecondaryNeutral } from '~/features/ui-kit';
import { MMText, MMPopupDefault } from '@mm-frontend/mm-web-ui-kit';

defineEmits<{ (event: 'close', isConfirmed: boolean): void }>();
</script>

<template>
  <MMPopupDefault :is-closable="false" @close="$emit('close', false)">
    <template #default>
      <div class="remove-confirm">
        <div class="remove-confirm__text">
          <MMText font="Title L/Semibold">Данные не сохранятся</MMText>
          <MMText font="Body L/Regular Long">
            Если выйти сейчас, придётся заполнять всё заново
          </MMText>
        </div>

        <div class="remove-confirm__buttons">
          <ButtonPrimaryAccented w100 size="l48" @click="$emit('close', false)">
            Продолжить регистрацию
          </ButtonPrimaryAccented>

          <ButtonSecondaryNeutral w100 size="l48" @click="$emit('close', true)">
            Не сохранять
          </ButtonSecondaryNeutral>
        </div>
      </div>
    </template>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.remove-confirm
  display flex
  flex-direction column
  gap 20px
  +Media(Laptop, Desktop, DesktopMax)
    width 300px

  &__text
    display flex
    flex-direction column
    gap 8px

  &__buttons
    display flex
    flex-direction column
    gap 12px
</style>
